import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import {MxGridModule, MxFormModule, MxButtonModule, MxInfoTooltipModule} from 'mx-core';
import { PrlProfilesRoutingModule } from './prl-profiles-routing.module';
import {PrlProfilesComponent} from './components/prl-profiles/prl-profiles.component';
import {
  PrlProfileEditComponent
} from './components/prl-profile-edit/prl-profile-edit.component';
import {PrlProfileAddComponent} from './components/prl-profile-add/prl-profile-add.component';
import {PrlLanguageModule} from '../prl-language/prl-language.module';


@NgModule({
  declarations: [
    PrlProfilesComponent,
    PrlProfileEditComponent,
    PrlProfileAddComponent
  ],
    imports: [
        CommonModule,
        MatCardModule,
        MxGridModule,
        MxFormModule,
        MxButtonModule,
        PrlProfilesRoutingModule,
        PrlLanguageModule,
        MxInfoTooltipModule
    ]
})
export class PrlProfilesModule {

}
